import { inject, Injector, provideAppInitializer } from '@angular/core';
import { NgbAlertConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

function initializeNgbConfigFactory(injector: Injector) {
  return () =>
    new Promise<any>((resolve: any) => {
      injector.get(NgbAlertConfig).dismissible = false;
      injector.get(NgbTooltipConfig).triggers = window.matchMedia('(pointer: coarse)').matches
        ? 'click:blur'
        : 'hover:focus';
      resolve();
    });
}

export const AppInitializerNgbConfig = provideAppInitializer(() => {
  const initializerFn = initializeNgbConfigFactory(inject(Injector));
  return initializerFn();
});
